import { createApp } from 'vue';
import App from './App.vue';
import AuthService from '@/services/authService.ts';
// Plugins
import { registerPlugins } from '@/plugins';
import PortalVue from 'portal-vue';

import '@/styles/main.scss';
import '@deepcloud/deep-ui-kit/dist/style.css';
import '@deepcloud/deep-ui-lib/dist/style.css';

import deepSignApi from '@/api/deepsign/deepsignApi.ts';
import deepadminApi from '@/api/deepadmin/deepadmin.ts';

AuthService.initKeycloak(onAuthFinish);
async function onAuthFinish() {
  const app = createApp(App);

  deepSignApi.defaults.headers.Authorization = AuthService.fullAccessToken;
  deepadminApi.defaults.headers.Authorization = AuthService.fullAccessToken;

  app.use(PortalVue);
  registerPlugins(app);
  app.mount('#app');

  // With this "hack" we force the KC token to be always updaten on window focus
  // this is needed for the logout from another domain like: deepsign.swiss

  // UPDATE: we need to update the token as soon as the tab get visible, not only when get focused
  // because the user can still click on a link that would cause an issue
  const isPublicDocument = window.location.href.includes('/p/document');
  if (AuthService.isAuthenticated && !isPublicDocument) {
    window.addEventListener(
      'focus',
      function () {
        AuthService.updateToken(-1);
      },
      false
    );

    document.addEventListener(
      'visibilitychange',
      function () {
        if (document.visibilityState === 'visible') {
          AuthService.updateToken(-1);
        }
      },
      false
    );
  }
}
